import React from 'react';
import {MultiRegressionGPU, MultiLogRegressionCPU} from 'prophesier/dist/wrapper/index-with-deps-react.min.js';
import Value from 'grommet/components/Value';
import Box from 'grommet/components/Box';
import Tiles from 'grommet/components/Tiles';
import NumberInput from 'grommet/components/NumberInput';


import Button from 'grommet/components/Button';
import Tile from 'grommet/components/Tile';
import Label from 'grommet/components/Label';
import Spinning from 'grommet/components/icons/Spinning';
import Publish from "./utils/Publish"

console.log(MultiLogRegressionCPU)

class BubbleSample extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            title: true,
            legends: true,
            exprt: false,
            b: null,
            constarray: [],
            r: null,
            x: 0,
            y: null,
            sse: null,
            showcomponent: false,
            start: false,
            iteration: 0,
            finalObjectAfterSplit: [],
            testObjectAfterSplit: [],
            finalNameFiltered: [],
            independentVariable: [],
            learningrate: props.currentElement === "Logistic Gradient Descent CPU" || props.currentElement === "Logistic Gradient Descent" ? 1 : props.currentElement === "Multi Linear Regression" ? 0.0000002 : 0.0003,
            iterations: 100,
            emailAlert: false,
            model: null,
            id: ""
             }
        this._onChange = this._onChange.bind(this)
        this._onresult = this._onresult.bind(this)
        this._onpredict = this._onpredict.bind(this)
        this._onpublish = this._onpublish.bind(this)
        this._onSubmit = this._onSubmit.bind(this)
    }
    componentDidMount() {
        const {dataNames} = this.props;
        //const dataObjectParsed = this.props.dataObject ? JSON.parse(this.props.dataObject.replace(/(\r\n|\n|\r|\s)/gm,"")) : []

        const length = this.props.dataObject[0].length;
        let finalObjectFiltered = [];
        let finalNameFiltered = [];
        this.props.dataObject.forEach((input, index) => {
            if (this.props.positionFilter.indexOf(index) > -1) {
                finalObjectFiltered.push(input);
                if (input.length !== length) {console.log("Data sources have different length")} else  {console.log("Data sources have same length. Good!")}
                finalNameFiltered.push(dataNames[`positionname${index+1}`]);
            }
        })

        let finalObjectAfterSplit = []
        let testObjectAfterSplit = []
        let cut;
        if (this.props.dataSplit === "80%-20%") {
            cut = Math.floor(length * 0.8)
        } else if (this.props.dataSplit === "70%-30%") {
            cut = Math.floor(length * 0.7)
        }
        finalObjectFiltered.forEach((ele, index)=>{
            let tempArray1 = []
            let tempArray2= []
            ele.forEach((ele2, index2)=> {
                if (index2 <= cut) {
                    tempArray1.push(ele2)
                } else if (index2 > cut) {
                    tempArray2.push(ele2)
                }
            })
            finalObjectAfterSplit.push(tempArray1)
            testObjectAfterSplit.push(tempArray2)
        })        
        //let lengthFinalObject = finalObjectFiltered.length;
        let independentVariable = finalObjectAfterSplit.pop()

        this.setState({showcomponent: true, finalObjectAfterSplit, testObjectAfterSplit, finalNameFiltered, independentVariable})


    }
    _onpublish(event) {
        const {constArray,
            b,
            type
     } = event.detail;
         const model = {constArray, b, type, mla: "mlrgd"}
         this.setState({emailAlert: true, model})
         //{"finalResultMeanVar":[{"count":16,"mean":1.9375,"variance":0.4625},{"count":16,"mean":3.875,"variance":0.5166666666666667},{"count":16,"mean":6.71875,"variance":1.1989583333333333},{"count":15,"mean":9.133333206176758,"variance":0.23423}],"epsilon":0.01,"steps":4,"minperiod":"6hh"}
         //Save in Google Sheet
     }
    _onSubmit(e) {
        this.setState({emailAlert: false})
    }
    _onChange(field, event) {
        console.log(event.target.value)      
        const {r2, scatter} = this.state
        switch(field) {
            case "learningrate":
                this.setState({ learningrate: event.target.value})
                break;
            case "iterations":
                this.setState({ iterations: event.target.value })
                break;
            case "r2":
                this.setState({ r2: !r2 })
                break;
            case "scatter":
                this.setState({ scatter: !scatter })
                break;
            
            case "error":
                this.setState({ error: event.target.value })
                break;
            case "predict":
                this.setState({ x: event.target.value})
                break;
        }
    }
    _onresult(event) {
        const {constarray, b, iteration, sse} = event.detail;
        this.setState({constarray, b, iteration, sse})
    }
    _onpredict(event) {
        //if (event.details.y === NaN) return
        const {y} = event.detail
        this.setState({y})
    }
    render() {
        const {b, constarray, 
            iteration, 
            sse, x, y, 
            showcomponent, start,
            finalObjectAfterSplit, 
            testObjectAfterSplit, 
            finalNameFiltered,
            independentVariable,
            learningrate,
            iterations,
            emailAlert, spinningFlag, model, email
        } = this.state

        let b2digits, y2digits, sse2digits;
        let constarray2digits = []
        if (b && constarray && iteration) {
            b2digits = b.toFixed(2)
            constarray2digits = constarray.map((element)=>{
                const value = element.toFixed(2)
                return value
            })
            sse2digits = sse.toFixed(2)
            y2digits = y ? y.toFixed(2) : "?"
        } else {
            b2digits = "?"
            constarray2digits = ["?", "?", "?"]
            sse2digits = "?"
            y2digits = y ? y.toFixed(2) : "?"
        }
        //MOVE WC TO NEW React Component. Then next does not need to happen on change state. which are really expensive
        

        let component;
        if (this.props.currentElement === "Multi Linear Regression") {
            component = <MultiRegressionGPU 
                xs={finalObjectAfterSplit} 
                ys={independentVariable}
                names={finalNameFiltered}
                x={x} 
                result={this._onresult} 
                predict={this._onpredict}
                learningrate={learningrate}
                batchsize={iterations}
                predictdata={testObjectAfterSplit}
                publish={this._onpublish}/>
        } else if (this.props.currentElement === "Multi Logistic Regression") {
            component = <MultiLogRegressionCPU 
                xs={finalObjectAfterSplit} 
                ys={independentVariable}
                names={finalNameFiltered}
                x={x} 
                result={this._onresult} 
                predict={this._onpredict}
                learningrate={learningrate}
                batchsize={iterations} 
                type={"logistic"}
                predictdata={testObjectAfterSplit}
                publish={this._onpublish}/>
        }
        let stringValue = ""
        constarray2digits.forEach((input, index)=>{
            if (index === 0) {
                stringValue = stringValue + `${input} * x${index + 1}`
            } else if (input >= 0) {
                stringValue = stringValue + ` + ${input} * x${index + 1}`
            } else {
                stringValue = stringValue + ` ${input} * x${index + 1}`
            }
            
        })
        const value = this.props.currentElement === "Multi Linear Regression"
        ? `f(x) = ${stringValue} + ${b2digits}`
        : `f(x) = 1 / e ^ (-1 * (${stringValue} + ${b2digits}))`

        let alert, spinningComponent;

         if (spinningFlag) {
            spinningComponent = <div style={{position: "fixed", backgroundColor: "white", top: "0px", 
            bottom: "0px", right: "0px", left: "0px", opacity: "0.5", paddingTop: "30%",
            zIndex: "500", textAlign: "center"}}>
                <Label>Loading...</Label>
                <Spinning size={"xlarge"}/>
            </div>
        } else {
            spinningComponent = <div></div>
        }

        //Publishing
         if (emailAlert) {
         alert = <Publish model={model} email={email} onSubmit={this._onSubmit} urlPredict={this.props.urlPredict}/>
         } else {
         alert = <div></div>
         }
         console.log(iteration)
        return (
            <div>
                {spinningComponent}
                {alert}
                <h2><strong>Run Model</strong></h2>
                <Box>
                <div style={{top: "10px", right: "0"}}>
                        <Box direction='row'
                                justify='center'
                                align='center'
                                wrap={true}
                                reverse={false}
                                margin='none'>
                                <Box direction='row'
                                    align='center'
                                    wrap={true}
                                    pad='small'
                                    margin='none'>
                                    <Label>
                                    Learning Rate
                                    </Label>
                                    <Box direction='row'
                                    align='center'
                                    wrap={true}
                                    pad='small'
                                    margin='none'>
                                        <NumberInput defaultValue={learningrate} step={0.001} onChange={this._onChange.bind(this, 'learningrate')} />
                                    </Box>
                                </Box>
                                <Box direction='row'    
                                    align='center'
                                    wrap={true}
                                    pad='small'
                                    margin='none'> 
                                    <Label>
                                        Iterations
                                    </Label>
                                    <Box direction='row'
                                    align='center'
                                    wrap={true}
                                    pad='small'
                                    margin='none'> 
                                        <NumberInput defaultValue={iterations} step={1} onChange={this._onChange.bind(this, 'iterations')} />
                                    </Box>
                                </Box>
                        </Box>
                        
                    </div>	  
                    <Tiles>
                    
                        <Tiles fill={true} flush={true} justify="center" responsive={true} selectable={true} size={"small"} onSelect={this._onSelect}>
                            <Tile pad={{"horizontal": "medium"}} colorIndex="light-1" key={0} style={{maxWidth: "300px"}}>
                                <Box pad="small" colorIndex="light">
                                    <Box align="center">
                                    <Value value={iteration}
                                        label='Iteration'
                                        size='medium'
                                        responsive={true}
                                    />
                                    </Box>
                                </Box>	
                            </Tile>
                            <Tile pad={{"horizontal": "medium"}} colorIndex="light-1" key={1} style={{maxWidth: "300px"}}>
                                <Box pad="small" colorIndex="light">
                                    <Box align="center">
                                        <Value value={value}
                                            label='Equation'
                                            size='medium'
                                            responsive={true}
                                        />
                                        </Box>
                                </Box>	
                            </Tile>
                            <Tile pad={{"horizontal": "medium"}} colorIndex="light-1" key={2} style={{maxWidth: "300px"}}>
                                <Box pad="small" colorIndex="light">
                                    <Box align="center">
                                        <Value value={sse2digits}
                                            label='Error'
                                            size='medium'
                                            responsive={true}
                                        />
                                    </Box>
                                </Box>	
                            </Tile>
                        </Tiles>
                    </Tiles>
                </Box>
                {/* <Box direction='row'    
                    align='center'
                    wrap={true}
                    pad='small'
                    margin='none'> 
                    <Label>
                        {"Predict"}
                    </Label>
                    <Box direction='row'
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'> 
                            <NumberInput 
                                defaultValue={x} 
                                step={1} 
                                onChange={this._onChange.bind(this, 'predict')} />
                    </Box>
                    <Box direction='row'
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'
                        style={{paddingLeft: "50px"}}> 
                             <Value value={y2digits}
                                            label='Prediction'
                                            size='medium'
                                            responsive={true}
                            />
                    </Box>
                </Box> */}
                 {(showcomponent) && component}
            </div>
        );
    }
}

export default BubbleSample;



// WEBPACK FOOTER //
// ./src/samples/run/mlrgd.js